export default {"src":"//prod.smassets.net/assets/smweb/_next/static/media/sparkle-white.16ad9dd6.svg","height":70,"width":106,"blurWidth":0,"blurHeight":0};